import { FormEvent, useState } from 'react'

import Button from '../../../components/button/Button'
import TagsInput from '../../../components/tags-input/TagsInput'
import { OnboardingStepProps } from '../types'
import { StepBody, StepFooter, ErrorBanner, Spacer } from '../styled'
import { COMMON_CANADIAN_CITIES } from '../helpers'

/**
 * Step 2: capture cities the renter is looking in.
 *
 * @param {OnboardingStepProps} props
 * @returns {JSX.Element}
 */
const CitiesStep = ({
  profile,
  onSubmit,
  onBack,
  isSubmitting,
}: OnboardingStepProps): JSX.Element => {
  const [cities, setCities] = useState<string[]>(
    profile?.unitPreferences.cities ?? [],
  )
  const [errorMessage, setErrorMessage] = useState<string>('')

  const handleSubmit = async (
    event: FormEvent<HTMLFormElement>,
  ): Promise<void> => {
    event.preventDefault()
    setErrorMessage('')

    if (cities.length === 0) {
      setErrorMessage('Add at least one city so we know where to look.')
      return
    }

    const previousPreferences = profile?.unitPreferences

    await onSubmit({
      unitPreferences: {
        priceMin: previousPreferences?.priceMin ?? null,
        priceMax: previousPreferences?.priceMax ?? null,
        bedroomCounts: previousPreferences?.bedroomCounts ?? [],
        bathroomCounts: previousPreferences?.bathroomCounts ?? [],
        propertyTypes: previousPreferences?.propertyTypes ?? [],
        dwellingScope: previousPreferences?.dwellingScope ?? 'no-preference',
        preferredMoveInDate: previousPreferences?.preferredMoveInDate ?? null,
        cities,
      },
    })
  }

  return (
    <form onSubmit={handleSubmit}>
      <StepBody>
        <TagsInput
          label="Cities you'd consider"
          value={cities}
          onChange={setCities}
          placeholder="Type a city and press Enter"
          helperText="Tap a suggestion or type your own."
          suggestions={COMMON_CANADIAN_CITIES}
        />
        {errorMessage !== '' ? <ErrorBanner>{errorMessage}</ErrorBanner> : null}
      </StepBody>
      <StepFooter>
        {onBack === null ? (
          <Spacer />
        ) : (
          <Button type="button" variant="ghost" onClick={onBack}>
            ← Back
          </Button>
        )}
        <Button type="submit" isLoading={isSubmitting}>
          Continue
        </Button>
      </StepFooter>
    </form>
  )
}

export default CitiesStep
